<template>
  <div class="tank-name" v-text="name.replace(/\s+/g, '\n')">
  </div>
</template>

<script>

export default {
  props: {
    name: { type: String }
  }
}
</script>

<style lang="scss">
.tank-name {
  white-space: pre-wrap;
}
</style>